module.exports = __webpack_public_path__ + "static/3M_2023_Financial_Reporting-8b59800e43fb6db2f06323ce242ba846.pdf";